import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Catalog } from './pages/Catalog';
import { ProductDetail } from './pages/ProductDetail';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
// Scroll to top on route change
const ScrollToTop = () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col bg-lab-black text-white selection:bg-lab-violetLight selection:text-white" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/catalog" element={<Catalog data-id="element-9" />} data-id="element-8" />
            <Route path="/product/:id" element={<ProductDetail data-id="element-11" />} data-id="element-10" />
            <Route path="/about" element={<About data-id="element-13" />} data-id="element-12" />
            <Route path="/contact" element={<Contact data-id="element-15" />} data-id="element-14" />
          </Routes>
        </main>
        <Footer data-id="element-16" />
      </div>
    </Router>;
}